import { NotifyMessageModel } from './../interfaces/notifyMessageModel';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserModel } from '../interfaces/UserModel';
import { SedeModel } from '../interfaces/sedeModel';
import { PrenotazioneModel, AutocertificazioneModel } from '../interfaces/prenotazioneModel';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { NewsModel } from '../interfaces/newsModel';
import { EventoAziendaleModel } from '../interfaces/eventoAziendaleModel';
import { RichiestaSedeModel, StatoRichiestaSede } from '../interfaces/richiestaSedeModel';

@Injectable({
  providedIn: 'root'
})
export class ApiService implements OnInit {

  baseUrl: string;
  endpointUser: string = "/users";
  endpointSedi: string = "/sedi";
  endpointPrenotazioni: string = "/prenotazioni";
  endpointNews: string = "/news";
  endpointNotify: string = "/notify";
  endpointAutocertificazioni: string = "/autocertificazioni";
  endpointEventi: string = "/eventi";
  endpointRichiesteSede: string = "/richieste-sede";

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  async getUserById(userId: string) {
    return await this.http.get<UserModel>(
      this.baseUrl.concat(this.endpointUser).concat("/").concat(userId)
    ).toPromise();
  }

  async getAllUserPromise(): Promise<UserModel[]> {
    const endpointUserWithFilter = this.endpointUser + '?_sort=funzione,lastName&_order=asc,asc';
    return await this.http.get<UserModel[]>(
      this.baseUrl.concat(endpointUserWithFilter)
    ).toPromise();
  }

  getAllUser(): Observable<UserModel[]> {
    return this.http.get<UserModel[]>(
      this.baseUrl.concat(this.endpointUser)
    );
  }

  async getUsersByFunzione(funzione: string): Promise<UserModel[]> {
    const endpointUserWithFilter = this.endpointUser + '?funzione=' + funzione + '&_sort=lastName&_order=asc';
    return await this.http.get<UserModel[]>(
      this.baseUrl.concat(endpointUserWithFilter)
    ).toPromise();
  }

  async getUsersOtherFunzione(funzione: string): Promise<UserModel[]> {
    const endpointUserWithFilter = this.endpointUser + '?funzione_ne=' + funzione + '&_sort=funzione,lastName&_order=asc,asc';
    return await this.http.get<UserModel[]>(
      this.baseUrl.concat(endpointUserWithFilter)
    ).toPromise();
  }

  async getAllSediPromise(): Promise<SedeModel[]> {
    return await this.http.get<SedeModel[]>(
      this.baseUrl.concat(this.endpointSedi)
    ).toPromise();
  }

  getAllSedi(): Observable<SedeModel[]> {
    return this.http.get<SedeModel[]>(
      this.baseUrl.concat(this.endpointSedi)
    );
  }

  async getSediDisponibili() {
    //TODO: MIGLIORARE LE API AL MOMENTO RITORNA TUTTO
    return await this.http.get<SedeModel[]>(
      this.baseUrl.concat(this.endpointSedi)
    ).toPromise();
  }

  async getAllPrenotazioniByUser(idUser: string) {
    let params = new HttpParams().set("idUser", idUser);
    return await this.http.get<PrenotazioneModel[]>(
      this.baseUrl.concat(this.endpointPrenotazioni), { "params": params }
    ).toPromise();
  }

  async getAllPrenotazioniPromise() {
    return await this.http.get<PrenotazioneModel[]>(
      this.baseUrl.concat(this.endpointPrenotazioni)
    ).toPromise();
  }

  getAllPrenotazioni(): Observable<PrenotazioneModel[]> {
    return this.http.get<PrenotazioneModel[]>(
      this.baseUrl.concat(this.endpointPrenotazioni).concat("/three-months")
    );
  }

  getAllNews(): Observable<NewsModel[]> {
    return this.http.get<NewsModel[]>(
      this.baseUrl.concat(this.endpointNews)
    );
  }

  async updateSede(sedeUpdated: SedeModel): Promise<SedeModel> {
    return await this.http.put<SedeModel>(
      this.baseUrl.concat(this.endpointSedi).concat("/").concat(sedeUpdated.id || sedeUpdated._id), sedeUpdated
    ).toPromise();
  }

  async insertSede(sedeToInsert: SedeModel): Promise<SedeModel> {
    return await this.http.post<SedeModel>(
      this.baseUrl.concat(this.endpointSedi), sedeToInsert
    ).toPromise();
  }

  async deleteSede(sedeUpdated: SedeModel): Promise<SedeModel> {
    return await this.http.delete<SedeModel>(
      this.baseUrl.concat(this.endpointSedi).concat("/").concat(sedeUpdated.id || sedeUpdated._id)
    ).toPromise();
  }

  async updateUser(userUpdated: UserModel): Promise<UserModel> {
    return await this.http.put<UserModel>(
      this.baseUrl.concat(this.endpointUser).concat("/").concat(userUpdated.id || userUpdated._id), userUpdated
    ).toPromise();
  }

  async deleteUser(userId: string): Promise<any> {
    await this.http.delete(
      this.baseUrl.concat(this.endpointUser).concat("/").concat(userId)
    ).toPromise();
  }

  async insertUser(userToInsert: UserModel): Promise<UserModel> {
    return await this.http.post<UserModel>(
      this.baseUrl.concat(this.endpointUser), userToInsert
    ).toPromise();
  }

  async insertPrenotazione(prenotazioneToInsert: PrenotazioneModel): Promise<PrenotazioneModel> {
    return await this.http.post<PrenotazioneModel>(
      this.baseUrl.concat(this.endpointPrenotazioni), prenotazioneToInsert
    ).toPromise();
  }

  async insertNews(newsToInsert: NewsModel): Promise<NewsModel> {
    return await this.http.post<NewsModel>(
      this.baseUrl.concat(this.endpointNews), newsToInsert
    ).toPromise();
  }

  async rimuoviPrenotazione(prenotazioneToDelete: PrenotazioneModel, cascade?: boolean): Promise<any> {
    let url = this.baseUrl.concat(this.endpointPrenotazioni).concat("/").concat(prenotazioneToDelete.id || prenotazioneToDelete._id);
    if (cascade) {
      url += '?cascade=true';
    }
    await this.http.delete(url).toPromise();
  }

  async rimuoviNews(newsToDelete: NewsModel): Promise<any> {
    await this.http.delete(
      this.baseUrl.concat(this.endpointNews).concat("/").concat(String(newsToDelete.id || newsToDelete._id))
    ).toPromise();
  }

  async updatePrenotazione(prenotazioneUpdated: PrenotazioneModel): Promise<any> {
    await this.http.put(
      this.baseUrl.concat(this.endpointPrenotazioni).concat("/").concat(prenotazioneUpdated.id || prenotazioneUpdated._id), prenotazioneUpdated
    ).toPromise();
  }

  async updateNews(newsUpdated: NewsModel): Promise<any> {
    await this.http.put(
      this.baseUrl.concat(this.endpointNews).concat("/").concat(String(newsUpdated.id || newsUpdated._id)), newsUpdated
    ).toPromise();
  }

  async salvaAutocertificazione(autocertificazione: AutocertificazioneModel): Promise<AutocertificazioneModel> {
    return await this.http.post<AutocertificazioneModel>(
      this.baseUrl.concat(this.endpointAutocertificazioni), autocertificazione
    ).toPromise();
  }

  async getAutocertificazioniByIdUtente(idUtente: string): Promise<AutocertificazioneModel[]> {
    return await this.http.get<AutocertificazioneModel[]>(
      this.baseUrl.concat(this.endpointAutocertificazioni + '?idUtente=' + idUtente)
    ).toPromise();
  }

  async deleteAutocertificazione(id: string): Promise<any> {
    await this.http.delete(
      this.baseUrl.concat(this.endpointAutocertificazioni).concat("/").concat(id)
    ).toPromise();
  }

  async insertNotify(notifyToInsert: NotifyMessageModel): Promise<NotifyMessageModel> {
    return await this.http.post<NotifyMessageModel>(
      this.baseUrl.concat(this.endpointNotify), notifyToInsert
    ).toPromise();
  }

  async updateNotify(notifyToInsert: NotifyMessageModel): Promise<NotifyMessageModel> {
    return await this.http.put<NotifyMessageModel>(
      this.baseUrl.concat(this.endpointNotify).concat("/").concat(notifyToInsert.id || notifyToInsert._id), notifyToInsert
    ).toPromise();
  }

  async getNotifyToReadUser(idUser: string): Promise<NotifyMessageModel[]> {
    const endpointNotifyWithFilter = `${this.endpointNotify}?idUserReceiver=${idUser}&flagLetto=false&_sort=dataInserimento&_order=desc`;
    return await this.http.get<NotifyMessageModel[]>(
      this.baseUrl.concat(endpointNotifyWithFilter)
    ).toPromise();
  }

  // ---- Richieste abilitazione sede ----

  async creaRichiestaSede(codiceSede: string, nota?: string): Promise<RichiestaSedeModel> {
    return await this.http.post<RichiestaSedeModel>(
      this.baseUrl.concat(this.endpointRichiesteSede), { codiceSede, nota }
    ).toPromise();
  }

  async getMieRichiesteSede(): Promise<RichiestaSedeModel[]> {
    return await this.http.get<RichiestaSedeModel[]>(
      this.baseUrl.concat(this.endpointRichiesteSede).concat('/mie')
    ).toPromise();
  }

  async getRichiesteSede(stato?: StatoRichiestaSede): Promise<RichiestaSedeModel[]> {
    const query = stato ? `?stato=${stato}` : '';
    return await this.http.get<RichiestaSedeModel[]>(
      this.baseUrl.concat(this.endpointRichiesteSede).concat(query)
    ).toPromise();
  }

  async approvaRichiestaSede(id: string): Promise<RichiestaSedeModel> {
    return await this.http.post<RichiestaSedeModel>(
      this.baseUrl.concat(this.endpointRichiesteSede).concat(`/${id}/approva`), {}
    ).toPromise();
  }

  async rifiutaRichiestaSede(id: string, motivo: string): Promise<RichiestaSedeModel> {
    return await this.http.post<RichiestaSedeModel>(
      this.baseUrl.concat(this.endpointRichiesteSede).concat(`/${id}/rifiuta`), { motivo }
    ).toPromise();
  }

  async annullaRichiestaSede(id: string): Promise<RichiestaSedeModel> {
    return await this.http.post<RichiestaSedeModel>(
      this.baseUrl.concat(this.endpointRichiesteSede).concat(`/${id}/annulla`), {}
    ).toPromise();
  }

  async getCalendarEvents(calendarId: string, date: Date, userEmail?: string): Promise<any[]> {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    let url = `${this.baseUrl}/google-calendar/events?calendarId=${encodeURIComponent(calendarId)}&date=${dateStr}`;
    if (userEmail) {
      url += `&userEmail=${encodeURIComponent(userEmail)}`;
    }
    return await this.http.get<any[]>(url).toPromise();
  }

  async createMeetingRoomEvent(payload: {
    organizerEmail: string;
    roomCalendarId?: string;
    summary: string;
    description?: string;
    startDateTime: string;
    endDateTime: string;
    attendeesEmails: string[];
  }): Promise<{ eventId: string | null; meetLink: string | null }> {
    const res = await this.http.post<{ eventId: string | null; meetLink: string | null }>(
      `${this.baseUrl}/google-calendar/meeting`,
      payload
    ).toPromise();
    return res || { eventId: null, meetLink: null };
  }

  async addAttendeesToMeeting(payload: {
    organizerEmail?: string;
    roomCalendarId?: string;
    eventId: string;
    attendeesEmails: string[];
  }): Promise<{ success: boolean }> {
    const res = await this.http.post<{ success: boolean }>(
      `${this.baseUrl}/google-calendar/meeting/attendees`,
      payload
    ).toPromise();
    return res || { success: false };
  }

  async sendNotifyEmail(payload: {
    userId: string;
    type: string;
    extraData: any;
  }): Promise<any> {
    return await this.http.post(
      this.baseUrl + '/notify/email',
      payload
    ).toPromise();
  }

  // ---- Eventi Aziendali ----

  getAllEventi(): Observable<EventoAziendaleModel[]> {
    return this.http.get<EventoAziendaleModel[]>(
      this.baseUrl.concat(this.endpointEventi)
    );
  }

  async insertEvento(evento: EventoAziendaleModel): Promise<EventoAziendaleModel> {
    return await this.http.post<EventoAziendaleModel>(
      this.baseUrl.concat(this.endpointEventi), evento
    ).toPromise();
  }

  async updateEvento(evento: EventoAziendaleModel): Promise<EventoAziendaleModel> {
    return await this.http.put<EventoAziendaleModel>(
      this.baseUrl.concat(this.endpointEventi).concat("/").concat(evento.id || evento._id), evento
    ).toPromise();
  }

  async deleteEvento(evento: EventoAziendaleModel): Promise<any> {
    await this.http.delete(
      this.baseUrl.concat(this.endpointEventi).concat("/").concat(evento.id || evento._id)
    ).toPromise();
  }

  async secureCheckIn(payload: {
    bookingId: string;
    codiceSede: string;
    hardwareUid: string;
    timestamp: number;
    signature: string;
  }): Promise<any> {
    return await this.http.post(
      `${this.baseUrl}${this.endpointPrenotazioni}/secure-checkin`,
      payload
    ).toPromise();
  }

  async forzaConfermaPrenotazione(id: string): Promise<any> {
    return await this.http.post(
      `${this.baseUrl}${this.endpointPrenotazioni}/${id}/force-confirm`,
      {}
    ).toPromise();
  }

  async loginSessionBridge(idToken: string): Promise<any> {
    const authUrl = this.baseUrl.replace('/acuplace-api', '') + '/acuplace/auth/login';
    return await this.http.post(
      authUrl,
      { token: idToken },
      { withCredentials: false }
    ).toPromise();
  }

  ngOnInit(): void {
    console.log("ngOnInit ApiService ")
  }
}
